// ─────────────────────────────────────────────────────────
//  O'zbekcha Lotin → Kirill transliteratsiya
//  FAQ bazasi lotinda saqlanadi; fuqaro kirill (uz_cy) tanlasa,
//  matn avtomatik kirillga o'giriladi. URL/havolalar o'zgarmaydi.
// ─────────────────────────────────────────────────────────

// Ko'p harfli birikmalar (tartib muhim — avval uzunroqlari)
const DIGRAPHS = [
  ["o‘", "ў"], ["o'", "ў"], ["oʻ", "ў"], ["g‘", "ғ"], ["g'", "ғ"], ["gʻ", "ғ"],
  ["sh", "ш"], ["ch", "ч"], ["yo", "ё"], ["yu", "ю"], ["ya", "я"], ["ye", "е"], ["ts", "ц"],
]
const DIGRAPHS_CAP = [
  ["O‘", "Ў"], ["O'", "Ў"], ["Oʻ", "Ў"], ["G‘", "Ғ"], ["G'", "Ғ"], ["Gʻ", "Ғ"],
  ["Sh", "Ш"], ["SH", "Ш"], ["Ch", "Ч"], ["CH", "Ч"], ["Yo", "Ё"], ["YO", "Ё"],
  ["Yu", "Ю"], ["YU", "Ю"], ["Ya", "Я"], ["YA", "Я"], ["Ye", "Е"], ["YE", "Е"],
]
const SINGLE = {
  a: "а", b: "б", d: "д", e: "е", f: "ф", g: "г", h: "ҳ", i: "и", j: "ж",
  k: "к", l: "л", m: "м", n: "н", o: "о", p: "п", q: "қ", r: "р", s: "с",
  t: "т", u: "у", v: "в", w: "в", x: "х", y: "й", z: "з", c: "с",
  A: "А", B: "Б", D: "Д", E: "Е", F: "Ф", G: "Г", H: "Ҳ", I: "И", J: "Ж",
  K: "К", L: "Л", M: "М", N: "Н", O: "О", P: "П", Q: "Қ", R: "Р", S: "С",
  T: "Т", U: "У", V: "В", W: "В", X: "Х", Y: "Й", Z: "З", C: "С",
  "'": "ъ", "ʼ": "ъ", "‘": "ъ",
}

function translitWord(w) {
  let s = w
  for (const [lat, cyr] of DIGRAPHS_CAP) s = s.split(lat).join(cyr)
  for (const [lat, cyr] of DIGRAPHS) s = s.split(lat).join(cyr)
  let out = ""
  for (const ch of s) out += (SINGLE[ch] !== undefined ? SINGLE[ch] : ch)
  return out
}

function looksLikeUrl(token) {
  return /^https?:\/\//i.test(token) || /(^|\/)t\.me\//i.test(token) ||
         /^www\./i.test(token) || token.includes("://") || /@[\w]+$/.test(token) ||
         /\.(uz|ru|com|org|net)(\/|$)/i.test(token)
}

/** Matnni kirillga o'giradi, ammo URL/havola/@username larni saqlaydi */
export function latinToCyrillic(text) {
  if (!text) return text
  // bo'shliqlarni saqlagan holda tokenlarga ajratamiz
  return text.split(/(\s+)/).map(tok => {
    if (!tok.trim()) return tok
    if (looksLikeUrl(tok)) return tok       // havolani tegmaymiz
    return translitWord(tok)
  }).join("")
}

/**
 * Fuqaro tiliga qarab FAQ/shablon matnini tanlaydi.
 * lang: 'ru' → ruscha (bo'lmasa lotin); 'uz_cy'/'uz-cyrl' → lotindan kirillga;
 *       aks holda (uz) → lotin.
 * ru bo'lsa transliteratsiya qilinmaydi.
 */
export function pickByLang(lang, { uz, ru } = {}) {
  const L = (lang || "uz").toLowerCase()
  if (L === "ru" || L === "rus" || L === "ru_ru") return ru || uz || ""
  if (L === "uz_cy" || L === "uz-cyrl" || L === "uzc" || L === "cy" || L === "kr") {
    return latinToCyrillic(uz || "")
  }
  return uz || ""
}

